<template>
  <b-container class="containerWrapper">
    <b-row>
      <b-col v-show="bucket.is_visible" v-for="bucket in buckets" :key="bucket.path" lg="3"> 
        <router-link :to="bucket.path" v-slot="{ navigate }">
          <b-card
            no-body
            :img-src="require('@/assets/img/dbTiles/' + bucket.image + '.png')"
            @click="navigate"
            img-top
            img-alt="Image"
            style="max-width: 20rem;cursor:pointer;margin-bottom:1.5rem;"
          >
            <b-card-title class="text-center m-0 card-tiles-height">{{
              bucket.title
            }}</b-card-title>
            <!-- <template #footer>
              <small class="text-muted">Last updated 3 mins ago</small>
            </template> -->
          </b-card>
        </router-link>
      </b-col>
    </b-row>
  </b-container>
</template>
<script>
//Import Packages
import { mapGetters, mapActions } from "vuex";

export default {
  name: "DbTiles",
  computed: {
    ...mapGetters({
      userBuckets: "userBuckets",
    }),
  },
  data() {
    return {
      buckets: []
    };
  },
  mounted() {
    this.resetBuckets();
  },
  methods: {
    resetBuckets() {
      this.buckets = [];
      this.userBuckets.forEach((element) => {
        if (this.buckets.length) {
          if (!this.buckets.find((item) => item.path === element.path)) {
            this.buckets.push({
              ...element,
              image:
                element.image.indexOf("/") >= 0
                  ? element.image.split("/")[0]
                  : element.image,
            });
          }
        } else {
          this.buckets.push({
            ...element,
            image:
              element.image.indexOf("/") >= 0
                ? element.image.split("/")[0]
                : element.image,
          });
        }
      });
    },
  },
  watch: {
    userBuckets: function() {
      this.resetBuckets();
    },
  },
};
</script>

<style lang="scss">
.containerWrapper {
  background: $color-white;
  position: relative;
  display: inline-block;
  margin: 0rem;
  padding: 1rem;
  height: 90%;
  overflow-y: auto;
  overflow-x: hidden;
  left: 15%;
  width: 84% !important;
  max-width: unset !important;
}

.tilesContainer {
  float: left;
  position: relative;
  width: 200px;
  height: 200px;
  margin: 13px 20px 0px 20px;
  display: none;
}

.tileIcon {
  background-size: cover !important;
  background-repeat: no-repeat !important;
  cursor: pointer;
  height: 80%;
  width: 100%;
}

.tileTilte {
  font-size: 18px;
  color: #61676e;
  text-align: center;
  margin-top: 3px;
}
.card-tiles-height {
  height: 70px;
}
</style>
